module.exports = __webpack_public_path__ + "3cef7f619d5bfe7ca56fd040f95461f8.woff";